import { render } from "./SlotCard.vue?vue&type=template&id=2cb0f35f&scoped=true"
import script from "./SlotCard.vue?vue&type=script&lang=js"
export * from "./SlotCard.vue?vue&type=script&lang=js"

import "./SlotCard.vue?vue&type=style&index=0&id=2cb0f35f&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb0f35f"]])

export default __exports__